import React from "react";
import { DeleteModalComponent, StandardTableComponent, TableEditActionComponent, TableDeleteActionComponent, TableToggleActiveAction } from "../../basics/table";
import Website from "../../../models/website/Website";
import { ListGroup, Tab } from "react-bootstrap";
import { Application, CountryHelper, CheckPermissions, GeneralSettingsHelper } from "../../../helpers";
import UserRolesEnum from "../../../enums/UserRolesEnum";
import { AdditionalFieldRepository, WebsiteRepository } from "../../../repository";
import { FormattedMessage } from "react-intl";
import FormattedMessageString from "../../basics/FormattedMessageString";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoaderComponent from "../../basics/layout/LoaderComponent";
import AdditionalFieldOverviewTreeComponent from "./AdditionalFieldOverviewTreeComponent";
import ToolTipLink from "../../basics/ToolTipLink";
import FormToastComponent from "../../basics/FormToastComponent";

class AdditionalFieldOverviewTableComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rows: this.props.rows,
            website: null,
            isLoading: true,
            toggler: [],
            language: Application.tableLanguage()
        };
    }

    componentDidMount() {
        WebsiteRepository.get(Website.get()).then(result => this.setState({ website: result, isLoading: false }));
    }

    columns(index) {
        return [
            {
                dataField: 'id',
                hidden: true
            },
            {
                dataField: 'field_key',
                text: <FormattedMessageString id="CMS.Modules.AdditionalFields.overview.table.field_key" />,
                sort: true,
                isDummyField: true,
                formatter: (_, row) => row.field_key
            },
            {
                dataField: 'field_key',
                text: <FormattedMessageString id="CMS.Modules.AdditionalFields.overview.table.field_type" />,
                sort: true,
                isDummyField: true,
                formatter: (_, row) => <FormattedMessageString id={'CMS.Modules.AdditionalFields.overview.table.field_type.' + row.field_type} />
            },
            {
                dataField: 'label',
                text: <FormattedMessageString id="CMS.Modules.AdditionalFields.overview.table.label" />,
                sort: true,
                isDummyField: true,
                formatter: (_, row) => row.contents[index]?.label
            },
            {
                dataField: 'required',
                text: <FormattedMessageString id="CMS.Modules.AdditionalFields.overview.table.is_required" />,
                sort: true,
                isDummyField: true,
                formatter: (_, row) => !!row.is_required
                    ? <FormattedMessageString id="CMS.Common.Yes" />
                    : <FormattedMessageString id="CMS.Common.No" />

            },
            {
                dataField: 'updated',
                text: <FormattedMessageString id="CMS.Modules.AdditionalFields.overview.table.last_updated" />,
                isDummyField: true,
                sort: true,
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    let contentsA = rowA.contents[index];
                    let contentsB = rowB.contents[index];

                    if (order === 'asc') {
                        return Date.parse(contentsA.updated_at) - Date.parse(contentsB.updated_at)
                    }
                    else if (order === 'desc') {
                        return Date.parse(contentsB.updated_at) - Date.parse(contentsA.updated_at)
                    }
                },
                formatter: (cellContent, row) => {
                    let contents = row.contents[index];
                    if (contents === undefined) return null;

                    return (
                        <div className="updated_by">
                            {contents.updated_at?.format('DD/MM/YYYY HH:mm:ss')}
                            {contents.updated_by && (<><br /><span className="small-highlighted-text"><FormattedMessageString id="CMS.Pages.overview.table.updated_by" /> {contents.updated_by}</span></>)}
                        </div>
                    )
                }
            },
            {
                dataField: 'actions',
                isDummyField: true,
                text: <FormattedMessage id="CMS.Table.actions" />,
                hidden: !CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR),
                sort: false,
                editable: false,
                headerStyle: (colum, colIndex) => {
                    return { width: '10%' };
                },
                formatter: (cellContent, row) => {
                    let content = row.contents[index];

                    return <div className="actions actions-end">
                        {row.field_type === 'select' && CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR) && !GeneralSettingsHelper.is() && (
                            <ToolTipLink className={"default"}
                                to={'/modules/' + this.props.parent.props.match.params.module + '/additionalfields/' + row.id + '/options'}
                                title="CMS.Modules.AdditionalFields.overview.tooltip.options"
                            >
                                <FontAwesomeIcon icon={['fa', 'list']} />
                            </ToolTipLink>

                        )}
                        {CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR) && !GeneralSettingsHelper.is() && (
                            <TableToggleActiveAction item={row} toggle={this.toggleActive} />
                        )}
                        {CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR) && !GeneralSettingsHelper.is() && (
                            <TableEditActionComponent id={row.id} path={'additionalfields/edit/' + row.id + '/' + content.language} />

                        )}
                        {CheckPermissions.role(this.props.user.roles, UserRolesEnum.WIZARD) && !GeneralSettingsHelper.is() && (
                            <TableDeleteActionComponent row={row} parent={this} />
                        )}
                    </div >
                }
            }
        ];
    }

    updateData = () => AdditionalFieldRepository.all(this.props.parent.props.match.params.module).then(response => this.props.parent.setState({ rows: response }));

    toggleActive = (_row) => AdditionalFieldRepository.toggle({ id: _row.id })
        .then(active => {
            let rows = this.state.rows.map(row => {
                if (row.id === _row.id) row.active = active;
                return row;
            });

            this.setState({ rows: rows, reload: true }, () => this.setState({ reload: false }));
        })
        .catch(() => FormToastComponent.errorTrans('CMS.Modules.AdditionalFields.overview.toggle.failed'));

    toggle = (event) => {
        let target = event.target.closest('button')
        let index = target.attributes['data-index'].value
        let viewType = target.attributes['data-view-type'].value

        this.props.parent.setState({ reload: true }, () => {
            this.props.parent.setState({ reload: false }, () => {
                let toggler = this.state.toggler;
                toggler[index] = viewType
                this.props.parent.table_ref.setState({ toggler: toggler, language: this.state.language })
            })
        })
    }

    table = (index) => (
        <div className={"custom-data-table AdditionalField"}>
            <StandardTableComponent keyField="id" data={this.state.rows} columns={this.columns(index)} search={false}
                title={this.props.title_id} type={this.props.type}
                custom={CheckPermissions.role(this.props.user.roles, UserRolesEnum.MANAGER) ? this.switch(index) : undefined}
                subRows={false}
                sort={{
                    dataField: 'published_at',
                    order: 'desc'
                }}
            />
            <DeleteModalComponent parent={this} />
        </div>
    )

    tree = (index) => (
        <div className={'custom-data-table teams'}>
            <div className="table-wrapper">
                <div className="table-header">
                    <FormattedMessage id="CMS.Module.overview.tree.title" values={{ module: <FormattedMessageString id={this.props.title_id} /> }}>{(value) => <p>{value}</p>}</FormattedMessage>
                    {this.switch(index)}
                </div>
                <AdditionalFieldOverviewTreeComponent data={this.state.rows} index={index} parent={this} />
            </div>
        </div>
    )

    switch = (index) => (
        <div className="toggle-tree" data-toggle="buttons" data-index={index}>
            <button type="button" data-toggle="button" data-view-type={"table"} data-index={index}
                onClick={this.toggle.bind(this)}
                disabled={this.state.toggler[index] !== undefined && this.state.toggler[index] === "tree" ? null : 'disabled'}>
                <FontAwesomeIcon icon={['far', 'th']} />
            </button>
            <button type="button" data-toggle="button" data-view-type={"tree"} data-index={index}
                onClick={this.toggle.bind(this)}
                disabled={this.state.toggler[index] !== undefined && this.state.toggler[index] === "tree" ? 'disabled' : ''}>
                <FontAwesomeIcon icon={['far', 'list']} />
            </button>
        </div>
    );

    render() {
        if (this.state.isLoading) return <LoaderComponent />;
        if (this.state.reload) return <LoaderComponent />;

        return (
            <div className="tab-tables">
                <Tab.Container id={"list-group-language-AdditionalFields"}
                    defaultActiveKey={"#" + (this.state.website.languages[this.state.language] !== undefined ? this.state.website.languages[this.state.language].language : this.state.website.languages[0].language)}>
                    <ListGroup>
                        {this.state.website.languages.map((language, index) => (
                            <ListGroup.Item action href={"#" + language.language} key={index}
                                onClick={() => this.setState({ language: index }, () => Application.setTableLanguage(index))}>
                                {CountryHelper.getLanguages().find(({ value }) => value + "" === language.language + "").label}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                    <Tab.Content>
                        {this.state.website.languages.map((language, index) => (
                            <Tab.Pane eventKey={"#" + language.language} key={index}>
                                {this.state.toggler[index] !== undefined && this.state.toggler[index] === "tree"
                                    ? this.tree(index)
                                    : this.table(index)
                                }
                            </Tab.Pane>
                        ))}
                    </Tab.Content>
                </Tab.Container>
            </div>
        );
    }
}

export default AdditionalFieldOverviewTableComponent;